import Hero from "./components/Hero";
import WinnersSlider from "./components/WinnersSlider";
import AsSeenOnLogos from "./components/AsSeenOnLogos";
import CarSpecs from "./components/CarSpecs";
import Gallery from "./components/Gallery";
import React, { useContext } from "react";
import CountdownTimer from "../../../components/Countdown/countdown";
import Button from "../../../components/Button/button";
import useXcCompetition from "./useXcCompetition";
import { CarCompetitionData } from "./contextProvider";
import EnterNowButton from "./EnterNowButton";

const CarCompetitionForMobile = () => {
  const carCompetition = useXcCompetition();
  const carCompetitionData = useContext(CarCompetitionData);
  const { isPrizeAvailable, countdownText, competitionEndDate } = carCompetitionData;
  const endDateTime = competitionEndDate || carCompetition.EndDateTime;

  return (
    <section className="flex flex-col justify-center gap-8 pb-[120px] font-jost">
      <Hero />
      <div className="flex flex-col gap-8 mx-4">
        <WinnersSlider />
        {isPrizeAvailable ? (
          <div className="fixed !top-auto bottom-0 left-0 right-0 z-[100] w-full max-lg:fixed">
            <div className="bg-black py-2">
              <div className="text-gray-4 text-center text-base font-semibold leading-5.5 tracking-[0]">
                {countdownText || carCompetition.SubtitleText || carCompetition.Title}
              </div>
              {endDateTime ? (
                <CountdownTimer
                  EndDateTime={new Date(endDateTime)}
                  textClass="uppercase text-gray-4 text-base leading-6 font-normal mr-1"
                  numericClass="text-primary font-bold text-base leading-6"
                  containerClass="flex justify-center items-center gap-[2px] leading-none"
                  format="d:h:m:s"
                />
              ) : null}
            </div>
            <EnterNowButton text="ENTER NOW" variation="mobile_sticky" place="car_new_floating_cta" />
          </div>
        ) : (
          <Button
            className="relative flex justify-center items-center gap-[11px] w-full h-[60px] p-4 text-[17px] font-medium uppercase text-gray-1 bg-white border border-solid border-gray-1 rounded-0"
            onClick={e => {
              e.stopPropagation();
            }}
            text="Not Currently Available"
          />
        )}
      </div>
      <CarSpecs />
      <div className="flex flex-col gap-8 mx-4 mb-8">
        <AsSeenOnLogos />
        <Gallery />
      </div>
    </section>
  );
};

export default CarCompetitionForMobile;
